// src/com/plan_stat/TransPlanStateForCompany.js
/* import React, { useState, useEffect } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TopContainer, Top, TopHeader, TopContent } from '../../common/TopStyle'; */
import TransPlanStateForDc from './TransPlanStateForDc';

/**
 * 배차현황
 * @returns 
 */
export default function TransPlanStateForCompany() {

    return(<TransPlanStateForDc />);
    /* return(
        <TopContainer>
            <TopHeader>
                배차현황
            </TopHeader>
            <TopContent style={{backgroundColor:'#EEE'}}>
                Content here
            </TopContent>
        </TopContainer>
    ); */
}
